export default __webpack_public_path__ + "static/boulevard-b6d8595e7a7f64124746a660ab1608fc.jpg";